import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Box, IconButton, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import InvestigationReport from './InvestigationReportContent';
import { getinvestigationInfo, Investigation } from './reportHelper';
import { generatePDF } from '../../../../../utils/reportUtils';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

type InvestigationPDFDialogProps = {
  open: boolean; 
  onClose: () => void;
};

const InvestigationPDFDialog: React.FC<InvestigationPDFDialogProps> = ({ open, onClose }) => {
  const reportRef = useRef<HTMLDivElement>(null);
  const { id } = useParams();
  const [investigations, setInvestigations] = useState<Investigation[]>([]);

  useEffect(() => {
    if (open && id) {
      getinvestigationInfo(`patient_id=${id}`).then((data) => {
        setInvestigations(data?.objects || []);
      });
    }
  }, [open, id]);

  const handleDownloadPDF = () => {
    if (reportRef.current) {
      generatePDF(reportRef.current, 'Investigation_Report');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>Investigation Report</span>
          <Box display="flex" alignItems="center">
            {investigations && investigations.length > 0 ? (
              <Button
                variant="contained"
                onClick={handleDownloadPDF}
                sx={{
                  backgroundColor: '#404040',
                  color: 'white',
                  '&:hover': { backgroundColor: '#505050' },
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  textTransform: 'capitalize',
                }}
              >
                <DownloadIcon sx={{ color: 'white' }} />
            Download Report
              </Button>
            ) : (
              <Typography variant="body2" sx={{ color: 'gray' }}>
            No report available to download.
              </Typography>
            )}
            <IconButton onClick={onClose} aria-label="close" sx={{ ml: 2 }}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        <div ref={reportRef}>
          {investigations.length > 0 && <InvestigationReport investigations={investigations} />}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InvestigationPDFDialog;
